// TODO: Crash games should fall-back to hiding Lobby for undefined configs. Pass a flag to differentiate a "game type".
export const isLobbyButtonHidden = (tableConfig?: boolean, casinoConfig?: boolean): boolean => {
  // Table config level is final and overrides casino config. Fall-back to displaying Lobby for undefined configs.
  return Boolean(tableConfig ?? casinoConfig);
};
